module.exports = __webpack_public_path__ + "img/logo.78ab5aca.png";